import { render, staticRenderFns } from "./SubCuentaPage.vue?vue&type=template&id=c6b06948"
import script from "./SubCuentaPage.js?vue&type=script&lang=js&external"
export * from "./SubCuentaPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports